// extracted by mini-css-extract-plugin
export default {"SelectWithArchivedStatus":"FieldTagsSelector_SelectWithArchivedStatus__Bki7A"};